<template>
    <div>
        <div v-if="student_id">
            <SidebarDropdown>
                <template v-slot:button>
                    <svg
                        :class="version.iconClasses"
                        class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        stroke="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.2199 2.8699L20.6299 6.2799C20.9299 6.5799 21.0999 6.9899 21.0999 7.4099V19.9999C21.0999 20.8799 20.3799 21.5999 19.4999 21.5999H4.4999C3.6199 21.5999 2.8999 20.8799 2.8999 19.9999V3.9999C2.8999 3.1199 3.6199 2.3999 4.4999 2.3999H16.0899C16.5099 2.3999 16.9199 2.5699 17.2199 2.8699ZM19.4999 20.3999C19.7199 20.3999 19.8999 20.2199 19.8999 19.9999V7.4099C19.8999 7.3099 19.8599 7.2099 19.7799 7.1299L16.3699 3.7199C16.2999 3.6399 16.1899 3.5999 16.0899 3.5999H4.4999C4.2799 3.5999 4.0999 3.7799 4.0999 3.9999V19.9999C4.0999 20.2199 4.2799 20.3999 4.4999 20.3999H19.4999ZM6.9999 8.0999H13.9999C14.3299 8.0999 14.5999 7.8299 14.5999 7.4999C14.5999 7.1699 14.3299 6.8999 13.9999 6.8999H6.9999C6.6699 6.8999 6.3999 7.1699 6.3999 7.4999C6.3999 7.8299 6.6699 8.0999 6.9999 8.0999ZM6.9999 11.3999H16.9999C17.3299 11.3999 17.5999 11.6699 17.5999 11.9999C17.5999 12.3299 17.3299 12.5999 16.9999 12.5999H6.9999C6.6699 12.5999 6.3999 12.3299 6.3999 11.9999C6.3999 11.6699 6.6699 11.3999 6.9999 11.3999ZM6.9999 15.8999H16.9999C17.3299 15.8999 17.5999 16.1699 17.5999 16.4999C17.5999 16.8299 17.3299 17.0999 16.9999 17.0999H6.9999C6.6699 17.0999 6.3999 16.8299 6.3999 16.4999C6.3999 16.1699 6.6699 15.8999 6.9999 15.8999Z"
                        />
                    </svg>
                    {{ $t('messages.attendance') }}
                </template>
                <template v-slot:items>
                    <a
                        :href="route('families.attendance.index')"
                        class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    >
                        {{ $t('messages.absences') }}
                    </a>
                    <a
                        :href="route('families.delays.index')"
                        class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    >
                        {{ $t('messages.delay') }}
                    </a>
                </template>
            </SidebarDropdown>

            <SidebarDropdown v-if="false">
                <template v-slot:button>
                    <svg
                        :class="version.iconClasses"
                        class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        stroke="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.2199 2.8699L20.6299 6.2799C20.9299 6.5799 21.0999 6.9899 21.0999 7.4099V19.9999C21.0999 20.8799 20.3799 21.5999 19.4999 21.5999H4.4999C3.6199 21.5999 2.8999 20.8799 2.8999 19.9999V3.9999C2.8999 3.1199 3.6199 2.3999 4.4999 2.3999H16.0899C16.5099 2.3999 16.9199 2.5699 17.2199 2.8699ZM19.4999 20.3999C19.7199 20.3999 19.8999 20.2199 19.8999 19.9999V7.4099C19.8999 7.3099 19.8599 7.2099 19.7799 7.1299L16.3699 3.7199C16.2999 3.6399 16.1899 3.5999 16.0899 3.5999H4.4999C4.2799 3.5999 4.0999 3.7799 4.0999 3.9999V19.9999C4.0999 20.2199 4.2799 20.3999 4.4999 20.3999H19.4999ZM6.9999 8.0999H13.9999C14.3299 8.0999 14.5999 7.8299 14.5999 7.4999C14.5999 7.1699 14.3299 6.8999 13.9999 6.8999H6.9999C6.6699 6.8999 6.3999 7.1699 6.3999 7.4999C6.3999 7.8299 6.6699 8.0999 6.9999 8.0999ZM6.9999 11.3999H16.9999C17.3299 11.3999 17.5999 11.6699 17.5999 11.9999C17.5999 12.3299 17.3299 12.5999 16.9999 12.5999H6.9999C6.6699 12.5999 6.3999 12.3299 6.3999 11.9999C6.3999 11.6699 6.6699 11.3999 6.9999 11.3999ZM6.9999 15.8999H16.9999C17.3299 15.8999 17.5999 16.1699 17.5999 16.4999C17.5999 16.8299 17.3299 17.0999 16.9999 17.0999H6.9999C6.6699 17.0999 6.3999 16.8299 6.3999 16.4999C6.3999 16.1699 6.6699 15.8999 6.9999 15.8999Z"
                        />
                    </svg>
                    {{ $tc('messages.activities', 2) }}
                </template>
                <template v-slot:items>
                    <a
                        :href="route('families.activities.index')"
                        class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                        v-if="false"
                    >
                        {{ $t('messages.list') }}
                    </a>
                    <a
                        :href="route('families.grades.index')"
                        class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    >
                        {{ $tc('messages.grades', 2) }}
                    </a>
                </template>
            </SidebarDropdown>

            <div>
                <a
                    :href="route('families.grades.index')"
                    :class="version.anchorClasses"
                    class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    <svg
                        :class="version.iconClasses"
                        class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        stroke="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.2199 2.8699L20.6299 6.2799C20.9299 6.5799 21.0999 6.9899 21.0999 7.4099V19.9999C21.0999 20.8799 20.3799 21.5999 19.4999 21.5999H4.4999C3.6199 21.5999 2.8999 20.8799 2.8999 19.9999V3.9999C2.8999 3.1199 3.6199 2.3999 4.4999 2.3999H16.0899C16.5099 2.3999 16.9199 2.5699 17.2199 2.8699ZM19.4999 20.3999C19.7199 20.3999 19.8999 20.2199 19.8999 19.9999V7.4099C19.8999 7.3099 19.8599 7.2099 19.7799 7.1299L16.3699 3.7199C16.2999 3.6399 16.1899 3.5999 16.0899 3.5999H4.4999C4.2799 3.5999 4.0999 3.7799 4.0999 3.9999V19.9999C4.0999 20.2199 4.2799 20.3999 4.4999 20.3999H19.4999ZM6.9999 8.0999H13.9999C14.3299 8.0999 14.5999 7.8299 14.5999 7.4999C14.5999 7.1699 14.3299 6.8999 13.9999 6.8999H6.9999C6.6699 6.8999 6.3999 7.1699 6.3999 7.4999C6.3999 7.8299 6.6699 8.0999 6.9999 8.0999ZM6.9999 11.3999H16.9999C17.3299 11.3999 17.5999 11.6699 17.5999 11.9999C17.5999 12.3299 17.3299 12.5999 16.9999 12.5999H6.9999C6.6699 12.5999 6.3999 12.3299 6.3999 11.9999C6.3999 11.6699 6.6699 11.3999 6.9999 11.3999ZM6.9999 15.8999H16.9999C17.3299 15.8999 17.5999 16.1699 17.5999 16.4999C17.5999 16.8299 17.3299 17.0999 16.9999 17.0999H6.9999C6.6699 17.0999 6.3999 16.8299 6.3999 16.4999C6.3999 16.1699 6.6699 15.8999 6.9999 15.8999Z"
                        />
                    </svg>
                    {{ $tc('messages.grades', 2) }}
                </a>
            </div>

            <div>
                <a
                    :href="route('families.fouls.index')"
                    :class="version.anchorClasses"
                    class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    <svg
                        :class="version.iconClasses"
                        class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        stroke="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M18.615 3.13745H5.38496C4.11496 3.13745 3.08496 4.16745 3.08496 5.43745V18.6675C3.08496 19.9375 4.11496 20.9675 5.38496 20.9675H18.615C19.885 20.9675 20.915 19.9375 20.915 18.6675V5.43745C20.915 4.16745 19.885 3.13745 18.615 3.13745ZM19.715 18.6575C19.715 19.2675 19.225 19.7575 18.615 19.7575H5.38496C4.77496 19.7575 4.28496 19.2675 4.28496 18.6575V5.43745C4.28496 4.82745 4.77496 4.33745 5.38496 4.33745H18.615C19.225 4.33745 19.715 4.82745 19.715 5.43745V18.6575ZM12.5149 5.26758H11.4849C10.9749 5.26758 10.4749 5.48758 10.1249 5.87758C9.75494 6.28758 9.56494 6.85758 9.62494 7.41758L10.1349 12.4076C10.2349 13.3976 11.0349 14.1476 11.9949 14.1476C12.9549 14.1476 13.7449 13.3976 13.8549 12.4076L14.3649 7.41758C14.4249 6.84758 14.2449 6.28758 13.8649 5.87758C13.5249 5.49758 13.0249 5.26758 12.5149 5.26758ZM12.6649 12.2876C12.6249 12.6676 12.3449 12.9476 12.0049 12.9476C11.6649 12.9476 11.3849 12.6676 11.3449 12.2876L10.8349 7.29758C10.8149 7.06758 10.8849 6.84758 11.0249 6.67758C11.1549 6.53758 11.3149 6.45758 11.4949 6.45758H12.5249C12.7049 6.45758 12.8649 6.53758 12.9949 6.67758C13.1449 6.83758 13.2149 7.06758 13.1849 7.29758L12.6649 12.2876ZM10.205 16.9775C10.205 15.9875 11.015 15.1875 12.005 15.1875C12.995 15.1875 13.805 15.9875 13.805 16.9775C13.805 17.9675 12.995 18.7675 12.005 18.7675C11.015 18.7675 10.205 17.9675 10.205 16.9775ZM11.205 16.9775C11.205 17.4075 11.565 17.7675 12.005 17.7675C12.445 17.7675 12.805 17.4175 12.805 16.9775C12.805 16.5475 12.445 16.1875 12.005 16.1875C11.565 16.1875 11.205 16.5375 11.205 16.9775Z"
                        />
                    </svg>
                    {{ $tc('messages.fouls', 2) }}
                </a>
            </div>

            <div>
                <a
                    :href="route('families.bulletins.index')"
                    :class="version.anchorClasses"
                    class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    <IconSpeakerphone
                        :class="version.iconClasses"
                        class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    />
                    {{ $tc('messages.bulletins', 2) }}
                </a>
            </div>

            <div>
                <a
                    :href="route('families.payments.index')"
                    :class="version.anchorClasses"
                    class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    <svg
                        :class="version.iconClasses"
                        class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        stroke="none"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    {{ $tc('messages.payments', 2) }}
                </a>
            </div>

            <div>
                <a
                    :href="route('families.meetings.index')"
                    :class="version.anchorClasses"
                    class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    <IconCalendarEvent
                        :class="version.iconClasses"
                        class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    />
                    {{ $tc('messages.request_meeting_turn', 2) }}
                </a>
            </div>
        </div>

        <div v-if="students.length" class="mt-5">
            <div class="text-indigo-200 flex justify-center">
                {{ $tc('messages.students', 2) }}
            </div>
            <ul>
                <li v-for="student in students">
                    <a
                        :href="route('families.selector.select', student.id)"
                        :class="student_id === student.id ? 'bg-gray-600' : ''"
                        class="block px-6 py-3 hover:bg-gray-700 rounded-lg"
                    >
                        <span class="flex items-center">
                            <img :src="student.avatar_or_default" alt="avatar" class="shrink-0 h-6 w-6 rounded-full" />
                            <span
                                :class="student_id === student.id ? 'text-gray-100' : 'text-gray-300'"
                                class="ml-3 block truncate"
                            >
                                {{ student.first_name }}
                            </span>
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import SidebarDropdown from '@/components/SidebarDropdown.vue';
import { IconCalendarEvent, IconSpeakerphone } from '@tabler/icons-vue';

export default {
    name: 'SidebarItemsForTeacher',
    components: {
        SidebarDropdown,
        IconSpeakerphone,
        IconCalendarEvent,
    },
    props: {
        roles: {
            type: Array,
            required: false,
            default: () => [],
        },
        students: {
            roles: {
                type: Array,
                required: false,
                default: () => [],
            },
        },
        student_id: {
            roles: {
                type: Number,
                required: false,
                default: null,
            },
        },
    },
    data() {
        return {
            version: {
                iconClasses: 'mr-3',
                anchorClasses: 'text-sm leading-5',
            },
            mobile: {
                iconClasses: 'mr-4',
                anchorClasses: 'text-base leading-6',
            },
            desktop: {
                iconClasses: 'mr-3',
                anchorClasses: 'text-sm leading-5',
            },
            // students: this.$page.props.auth.children,
            // student_id: this.$page.props.auth.student_id,
        };
    },
    methods: {
        hasRole(role) {
            return this.roles.includes(role);
        },
    },
};
</script>
